export const style = {
  h3: {
    fontSize: `24px`,
    fontWeight: 300,
    color: `black`,
    margin: `0 0 32px 0`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/News/partials/SingleArticle/style/headers.js